// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2GAv7","title":"Images45_title__vQMyl","images":"Images45_images__2HJPW"};